import gsap from 'gsap'
import barba from '@barba/core'
import { initLenis, scrollToStart, parallax } from './lenis'
import { initAlpine } from './alpine'
import { navigation } from './navigation.js'
import { animation } from './animation.js'
import { initSwiper } from './swiper.js'

const initBarba = () => {
	window.initialLoad = true

	const initComponents = (data) => {
		initSwiper()
	}

	barba.init({
		debug: true,
		timeout: 10000,
		schema: {
			prefix: 'data-load'
		},
		transitions: [
			{
				name: 'transition',
				once(data) { },
				leave(data) {
					const done = this.async()

					gsap.to(data.current.container, {
						opacity: 0,
						duration: 0.35,
						onComplete: done
					})
				},
				afterLeave() {
					scrollToStart()
					ScrollTrigger.getAll().forEach(t => t.kill())
				},
				after(data) {
					const done = this.async()

					gsap.from(data.next.container, {
						opacity: 0,
						duration: 0.35,
						onComplete: done
					})
				}
			},
			{
				name: 'transition-between-types',
				sync: true,
				from: {
					custom: (data) => {
						return data.trigger && data.trigger.classList.contains('page-links__button')
					}
				},
				leave(data) {
					const done = this.async()
					done()
				},
				afterLeave() {
					removeCursorState()
					nav.closeNavigation()
					ScrollTrigger.getAll().forEach(t => t.kill())
				},
				after(data) {
					const done = this.async()
					done()
				}
			}
		]
	})

	barba.hooks.once((data) => {
		initLenis()
		initAlpine()
		initComponents(data)

		window.onload = function() {
			window.initialLoad = false
			document.documentElement.classList.add('is-ready')
		}
	})

	barba.hooks.beforeLeave((data) => {
		gsap.killTweensOf('*')
	})

	barba.hooks.after((data) => {
		initComponents(data)
	})

}

export default initBarba